import apiClient from './client.js';

export async function fetchTags() {
  const { data } = await apiClient.get('/tags');
  return data?.data || [];
}

/** Tags present on leads inside the caller's role scope — the «Мои» filter bar. */
export async function fetchTagsMine() {
  const { data } = await apiClient.get('/tags', { params: { scope: 'mine' } });
  return data?.data || [];
}

export async function createTag({ label, color }) {
  const { data } = await apiClient.post('/tags', { label, color });
  return data;
}

export async function updateTag(id, { label, color }) {
  const { data } = await apiClient.put(`/tags/${id}`, { label, color });
  return data;
}

export async function deleteTag(id) {
  const { data } = await apiClient.delete(`/tags/${id}`);
  return data;
}

export async function assignTag(leadId, tagId) {
  const { data } = await apiClient.post(`/tags/leads/${leadId}/${tagId}`);
  return data;
}

/** TRACK-B-1b §3.8 — attach by free-text label; the tag is created server-side if new. */
export async function assignTagByLabel(leadId, tagLabel) {
  const { data } = await apiClient.post(`/tags/leads/${leadId}`, { tagLabel });
  return data;
}

export async function removeTag(leadId, tagId) {
  const { data } = await apiClient.delete(`/tags/leads/${leadId}/${tagId}`);
  return data;
}
